export default [
  { name: 'EUR', value: 'EUR' },
  { name: 'USD', value: 'USD' },
];
